import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../../components/AppHeader';
import '../Common.css';
import '../Dashboard.css';
import '../header.css';

/**
 * TimetableManage Page - Timetable Portal
 *
 * Manage existing class timetables and schedules
 */
const TimetableManage = () => {
    const navigate = useNavigate();

    return (
        <div className="dashboard-container org-console">
            <AppHeader />

            {/* Main Content */}
            <div className="dashboard-main">
                <div className="dashboard-content-wrapper" style={{ maxWidth: '800px' }}>
                    <div className="sub-portal-header-card">
                        <div className="sub-portal-header-title-row">
                            <button
                                onClick={() => navigate('/timetables')}
                                className="back-nav-btn"
                            >
                                ← Timetable Portal
                            </button>
                            <h1 className="sub-portal-header-title">Manage Timetables</h1>
                        </div>
                        <p className="sub-portal-header-subtitle">
                            Edit existing schedules and handle class cancellations or updates
                        </p>
                    </div>

                    <div className="content-card" style={{ textAlign: 'center', padding: '60px 40px' }}>
                        <div style={{
                            background: 'rgba(16, 191, 191, 0.1)',
                            padding: '30px',
                            borderRadius: '12px'
                        }}>
                            <p style={{ fontSize: '1.1rem', color: '#451f78', marginBottom: '15px' }}>
                                <strong>Coming Soon!</strong>
                            </p>
                            <p style={{ color: '#666', lineHeight: '1.6' }}>
                                This portal will allow you to manage your existing class timetables, edit schedules,
                                and handle class cancellations or updates. For now, use the Timetables tab from the main dashboard.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimetableManage;
